import DashboardLayout from '../../components/Layout/DashboardLayout';
import AdminApplications from '../../components/Admin/AdminApplications';
import { applicationStatusMap } from '../../config/applicationStatusConfig';

const NodalIncompleteInformationApplications = () => {
  return (
    <DashboardLayout pageTitle="Application" mainClass="p-6">
      <AdminApplications
        title="Nodal Incomplete Information Applications"
        status={[applicationStatusMap?.nodalIncompleteInformation.value]}
        stage={[]}
      />
    </DashboardLayout>
  );
}

export default NodalIncompleteInformationApplications